import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container, Row, Col, Carousel, Card } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaTwitter, FaPhone, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../home/Header';
import Footer from '../home/Footer';
import '../styles/Styles.css';
import '../styles/Bootstrap.css';
import IN1 from '../../../images/in01.png';
import IN2 from '../../../images/in02.png';
import IN3 from '../../../images/in03.jpg';
import IN4 from '../../../images/in04.png';
import IN5 from '../../../images/in05.png';
import emailicon from '../../../images/email.png';
import twittericon from '../../../images/twitter.png';
import whatsappIcon from '../../../images/whatspp.png';
import about from '../../../images/ab01.jpg';
import Arrow from './Arrow';

const InteriorProducts = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const services = [
        { title: 'DSX cupboard doors hinge/WJY1201C', subtitle: 'DSX cupboard doors hinge/WJY1201C/Old code WJY12A3/Cold rolled sheet/Nickel', imgSrc: IN1 },
        { title: 'Handle/WLS91020', subtitle: 'Handle/WLS91020/Old code YL1102/304/Mirror/8-12MM', imgSrc: IN2 },
        { title: 'Fix clamp/WWB12020', subtitle: 'Fix clamp/WWB12020/Old code WB1202/T=8-12/304/Mirror/JY', imgSrc: IN3 },
        { title: 'Handle/WLS1105A', subtitle: 'Handle/WLS1105A/B=475/D=275MM/304/Mirror/T=8-12MM/XK/Z/Standard', imgSrc: IN4 },
        { title: 'Fixed seat/WCG20020-19', subtitle: 'Fixed seat/WCG20020-19/304/Mirror/JY', imgSrc: IN5 },
    ];
    return (
        <div className="boxed_wrapper ltr">
            {loading ? (
                <div className="loader-wrap">
                    <div className="preloader">
                        <div id="handle-preloader" className="handle-preloader">
                            <div className="animation-preloader">
                                <div className="spinner"></div>
                                <div className="txt-loading">
                                    {['K', 'I', 'N', 'L', 'O', 'N', 'G'].map((letter, index) => (
                                        <span key={index} data-text-preloader={letter} className="letters-loading">
                                            {letter}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>

                    <Header />

                    <div className="breadcrumb-section" style={{ position: 'relative', padding: '50px 0', textAlign: 'center' }}>
                        <div
                            style={{
                                backgroundImage: `url(${about})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 1,
                            }}
                        >
                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgb(255 255 255 / 33%)',
                                zIndex: 2,
                            }}
                        ></div>

                        <Container fluid style={{ position: 'relative', zIndex: 3 }}>
                            <Breadcrumb className="breadcrumb mt-5">
                                <h1 style={{ color: '#ffffff', textDecoration: 'none', top: 29 }}>Interior <span style={{ color: '#2671ae' }}>Products</span></h1>
                            </Breadcrumb>
                        </Container>

                    </div>
                    <section className="service-section pt_70 pb_120 mt-5">
                        <Container fluid>
                            <Row>
                                {/* Sidebar */}
                                <Col lg={4} md={12}>
                                    <Card style={{ textAlign: 'center', borderRadius: '2em', boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)' }}>
                                        <div className="service-sidebar mr_40">
                                            <div className="category-widget mb_40">
                                                <ul className="category-list clearfix" style={{ padding: '20px' }}>
                                                    <li><Link to="/products" >Door & Window </Link></li>
                                                    <li className="mt-3"><Link to="/doorandcontrol">Door Control </Link></li>
                                                    <li className="mt-3"><Link to="/interiorproducts" className="current">Interior Products <FaArrowRight /> </Link></li>
                                                    <li className="mt-3"><Link to="/facade">Facade </Link></li>
                                                    <li className="mt-3"><Link to="/residentialprojects">Glass Railings </Link></li>
                                                    <li className="mt-3"><Link to="/residentialprojects">Commercial Products  </Link></li>
                                                    <li className="mt-3"><Link to="/residentialprojects">Steel Structure </Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>

                                {/* Content Area */}
                                <Col lg={8} md={12}>
                                    <div className="service-details-content">
                                        <Row>
                                            {services.map((service, index) => (
                                                <Col lg={4} md={4} sm={12} className="category-block" key={index}>
                                                    <Card className="service-block-one">
                                                        <div className="inner-box">
                                                            <figure className="image-box image-hov-two">
                                                                <img src={service.imgSrc} alt={service.title} />
                                                                <div className="overlay-image">
                                                                    <div className="lower-content">
                                                                        <h3>{service.title}</h3>
                                                                        <p className="subtitle-text">{service.subtitle}</p>
                                                                    </div>
                                                                </div>
                                                            </figure>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>



                    {/* WhatsApp Icon */}
                    <div className="whatsapp-icon" onClick={() => window.open('https://wa.me/+919108990182', '_blank')}>
                        <img src={whatsappIcon} alt="WhatsApp" width="60" />
                    </div>
                    <a href="mailto:inhr@kinlong.com" className="email-icon">
                        <img src={emailicon} alt="Email" width="60" />
                    </a>
                    <div
                        className="arrow-icon"
                        style={{
                            position: 'fixed',
                            bottom: '73px',
                            right: '20px',
                            cursor: 'pointer',
                            zIndex: 1000,
                        }}
                    >
                        <Arrow onClick={scrollToTop} />
                    </div>
                    <div className="sticky-social">
                        <a href="https://www.facebook.com/KinlongHardwareIndiaPvtLtd" target="_blank" className="social-link">
                            <FaFacebookF className="icon" style={{ color: '#4267B2', fontSize: '15px' }} />
                        </a>

                        <a href="https://www.instagram.com/kinlong_india" target="_blank" className="social-link">
                            <FaInstagram className="icon" style={{ color: '#E4405F', fontSize: '15px' }} />
                        </a>

                        <a href="https://www.linkedin.com/in/kinlong-india-766b98198" target="_blank" className="social-link">
                            <FaLinkedinIn className="icon" style={{ color: '#0077B5', fontSize: '15px' }} />
                        </a>

                        <a href="https://www.youtube.com/@kinlonghardwareindiapvtltd5906" target="_blank" className="social-link">
                            <FaYoutube className="icon" style={{ color: '#FF0000', fontSize: '15px' }} />
                        </a>

                        <a href="https://twitter.com/GKinlongHQ" target="_blank" className="social-link">
                            <img src={twittericon} alt="Twitter" width="60" />
                        </a>
                    </div>
                    {/* Footer Section */}
                    <section>
                        <Footer />
                    </section>
                </>
            )}
        </div>
    );
};

export default InteriorProducts;
